import React from "react";
import { Link } from "react-router-dom";
import { Plus } from "lucide-react";

export default function TreatmentCalendarsCard({ calendars, onNew }) {
  return (
    <div className="bg-white border border-stone-200 rounded-xl shadow-soft" data-testid="treatment-calendars-card">
      <div className="px-5 py-4 border-b border-stone-100 flex items-center justify-between">
        <h3 className="font-display font-semibold text-stone-900">Treatment calendars</h3>
        <button onClick={onNew} className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-brand-500 hover:bg-brand-700 text-white text-sm font-semibold" data-testid="new-calendar-btn">
          <Plus className="w-4 h-4" />New calendar
        </button>
      </div>
      <div className="divide-y divide-stone-100">
        {calendars.length === 0 && <div className="p-8 text-center text-stone-500 text-sm">No calendars yet. Create one to start scheduling treatments.</div>}
        {calendars.map((c) => (
          <Link key={c.id} to={`/calendars/${c.id}`} className="block px-5 py-4 hover:bg-stone-50 transition-colors" data-testid={`calendar-row-${c.id}`}>
            <div className="flex items-center justify-between gap-4">
              <div className="min-w-0">
                <div className="font-semibold text-stone-900 truncate">{c.regimen_name}</div>
                <div className="text-xs text-stone-500 mt-0.5">
                  Started {c.start_date} • {c.events?.length || 0} events • Provider: {c.provider_name}
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
